import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';

const StockUnknownIcon = props => {
  const { title, width, height, toneDown } = props;
  return (
    <svg
      className={styles['stock-unknown'].withModifier({
        'tone-down': toneDown,
      })}
      height={height}
      width={width}
      viewBox="0 0 29 11"
    >
      {title && <title>{title}</title>}
      <path
        d="M1 0L4 0 4 3 1 3 1 0ZM5 0L8 0 8 3 5 3 5 0ZM0 4L3 4 3 7 0 7 0 4ZM4 4L7 4 7 7 4 7 4 4ZM8 4L11 4 11 7 8 7 8 4ZM0 8L3 8 3 11 0 11 0 8ZM4 8L7 8 7 11 4 11 4 8ZM8 8L11 8 11 11 8 11 8 8ZM21.5 8.2L23.5 8.2 23.5 10.2 21.5 10.2 21.5 8.2ZM20.4 0.5C20.9 0.2 21.6 0 22.3 0 23.4 0 24.2 0.2 24.9 0.7 25.6 1.2 25.9 2 25.9 2.9 25.9 3.5 25.8 4 25.5 4.4 25.3 4.7 25 5 24.5 5.4L24 5.7C23.7 5.9 23.6 6.2 23.5 6.5 23.4 6.6 23.4 6.9 23.4 7.3L21.5 7.3C21.6 6.5 21.6 6 21.8 5.7 21.9 5.4 22.2 5 22.7 4.7L23.2 4.3C23.3 4.1 23.5 4 23.6 3.9 23.8 3.6 23.8 3.3 23.8 3 23.8 2.7 23.7 2.4 23.5 2.1 23.3 1.8 23 1.7 22.4 1.7 21.9 1.7 21.5 1.8 21.3 2.2 21.1 2.5 21 2.9 21 3.3L19 3.3C19.1 2 19.5 1.1 20.4 0.5Z"
        fill="#DBD9D8"
      />
    </svg>
  );
};

const { string, number, bool } = PropTypes;
StockUnknownIcon.propTypes = {
  title: string,
  height: number,
  width: number,
  toneDown: bool,
};

StockUnknownIcon.defaultProps = {
  height: 12,
  width: 30,
  title: undefined,
  toneDown: false,
};

export default StockUnknownIcon;
